import { render } from "./MultipleStores.vue?vue&type=template&id=fff93e3a"
import script from "./MultipleStores.vue?vue&type=script&lang=js"
export * from "./MultipleStores.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__